(function ($, njm) {
    'use strict';

    njm.views.verticalTabsMobile = Backbone.View.extend({

        events: {
			
        },

        // supported medias for this view
        medias: ['mobile'],

        /**
         * Initialize
         */
        initialize: function () {
			this.template = this.$el.parents('.comp-vertical-tabs').find('[data-template=comp-vertical-tabs-mobile]').html();

            // Render
            this.render();
			
        },

        /**
         * Render
         */
        render: function () {
            this.$el.html(this.template);
			new njm.views['accordion']({
				el: this.$('.comp-accordion')
			});
        }
		
    });
})(jQuery, njm);